import { useMutation, useQuery } from "react-query";
import * as beacon from "services/configuration/tag/tag";

export const useAddAlertList = () => {
  return useMutation((formData) => beacon.addAlertList(formData));
};

export const useAlertlist = () => {
  return useQuery("Alertlist", () => beacon.getAlertlist(), {
    enabled: false,
    retry: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};

export const useBeaconList = () => {
  return useMutation((formData) => beacon.getBeaconList(formData));
};

export const useAddBeacon = () => {
  return useMutation((formData) => beacon.addBeacon(formData));
};

export const useEditBeacon = () => {
  return useMutation((formData) => beacon.editBeacon(formData));
};

export const useDeleteBeacon = () => {
  return useMutation((formData) => beacon.deleteBeacon(formData));
};

export const useStatusTag = () => {
  return useMutation((formData) => beacon.statusTag(formData));
};
